<template>
<div class="user-medal-dialog-container">
  <medal-dialog-container 
    ref="dialog"
    v-if="showDialog"
    :appName="appName"
    :medalList="medalList" 
    @closeDialog="close"
  />
</div>
</template>

<script>
import MedalDialogContainer from './dialog';
import { getUnpopedCustomMedals } from './service';
export default {
  name: 'YxtbizUserMedalDailog',
  components: {
    MedalDialogContainer
  },
  data() {
    return {
      showDialog: false,
      medalList: [],
      queueList: [],
      // 手动获取的自定义勋章ID集合
      customGetIds: []
    };
  },
  props: {
    appName: {
      type: String,
      validator(value) {
        return ['kngpc', 'knglibpc', 'bbspc'].includes(value);
      }
    }
  },
  computed: {
  },
  created() {
    if (this.appName !== 'kngpc') {
      // kngpc目前业务方对接是课程学习，不弹自定义勋章
      this.getCustomMessage();
    }
    if (window.ImEventBus) {
      window.ImEventBus.$on('IM:getCmdMessage', (message) => {
        console.log('-------消息来了--------');
        console.log(message);
        this.getMessageData(message);
      });
    }
  },
  methods: {
    // 获取自定义勋章数据
    async getCustomMessage() {
      try {
        let datas = await getUnpopedCustomMedals();
        console.log('customList', datas);
        if (datas && datas.length > 0) {
          if (this.medalList.length > 0) {
            this.queueList = [...this.queueList, datas];
            console.log('open_queueList_custom', this.queueList);
          } else {
            this.medalList = datas;
            console.log('open_medalList_custom', this.medalList);
          }
          this.customGetIds = datas.map(i => i.medalDetailId);
          this.show();
        }
      } catch (error) {
        console.log(error);
      }
    },
    getMessageData(message) {
      let yxtMsgType = message.ext.yxtMsgType;
      if (yxtMsgType !== 52) {
        return;
      }
      let yxtMsgBody = typeof message.ext.yxtMsgBody === 'string' ? JSON.parse(message.ext.yxtMsgBody) : message.ext.yxtMsgBody;
      let datas = [];
      let validator = true;
      switch (this.appName) {
        // IM，筛选对应页面可弹勋章+未手动获取到的自定义勋章
        case 'kngpc':
          // kngpc目前业务方对接是课程学习，不弹自定义勋章（后期迭代：kngpc作为在线课堂一级页面对直接，课程学习页使用新的appname）
          datas = yxtMsgBody.filter(item=>['live_learn', 'day_day_up'].includes(item.medalTemplateCode));
          break;
        case 'knglibpc':
          // 知识库
          datas = yxtMsgBody.filter(item=>['accumulate_steadily'].includes(item.medalTemplateCode) || (item.medalDetailId && !this.customGetIds.includes(item.medalDetailId)));
          break;
        case 'bbspc':
          // 社区
          datas = yxtMsgBody.filter(item=>['moods_king'].includes(item.medalTemplateCode) || (item.medalDetailId && !this.customGetIds.includes(item.medalDetailId)));
          break;
        default: validator = false;
          console.error('appName must be one of \'kngpc\',\'knglibpc\',\'bbspc\'');
          break;
      }
      if (this.medalList.length > 0) {
        if (datas.length > 0) {
          this.queueList = [...this.queueList, datas];
        }
        console.log('open_queueList', this.queueList);
      } else {
        this.medalList = datas;
        console.log('open_medalList', this.medalList);
      }
      validator && this.show();
    },
    show() {
      this.showDialog = true;
      this.$nextTick(function() {
        this.$refs.dialog.show();
      });
    },
    close() {
      this.showDialog = false;
      if (this.queueList.length > 0) {
        this.medalList = [...this.queueList[0]];
        this.queueList.splice(0, 1);
        console.log('close_queueList', this.queueList);
        console.log('close_medalList', this.medalList);
        setTimeout(()=>{
          this.show();
        }, 300);
      } else {
        this.medalList = [];
      }
    }
  }
};
</script>
